import React from 'react';
import { DateInput, DateInputProps } from '@mantine/dates';

/**
 * BMDateInput - DateInput component with Bobex styling
 * Automatically highlights today's date with legacy yellow/beige background
 */
export interface BMDateInputProps extends DateInputProps {}

export const BMDateInput: React.FC<BMDateInputProps> = (props) => {
    // Function to highlight today's date with legacy style
    const getTodayDayProps = React.useCallback((date: Date | string) => {
        // Mantine passes ISO strings, convert to Date
        const dateObj = typeof date === 'string' ? new Date(date) : date;
        
        // Validate date object
        if (!dateObj || !(dateObj instanceof Date) || isNaN(dateObj.getTime())) {
            return {};
        }

        const today = new Date();
        today.setHours(0, 0, 0, 0);
        
        const compareDate = new Date(dateObj);
        compareDate.setHours(0, 0, 0, 0);
        
        const isToday = compareDate.getTime() === today.getTime();

        if (isToday) {
            return {
                className: 'bobex-today-date',
            };
        }
        return {};
    }, []);

    return (
        <>
            <style>
                {`
                    .bobex-today-date {
                        background-color: #FFE7A8 !important;
                        font-weight: 500 !important;
                    }
                `}
            </style>
            <DateInput {...props} getDayProps={getTodayDayProps} />
        </>
    );
};

export default BMDateInput;
